(()=>{'use strict';
 const campaign=window.FultonsNatuzziCampaign;if(!campaign)return;
 const setupAnnouncements=()=>document.querySelectorAll('[data-natuzzi-announcement]:not([data-notice-ready])').forEach(bar=>{
  const slides=[...bar.querySelectorAll('[data-notice-slide]')],next=bar.querySelector('[data-notice-next]'),pause=bar.querySelector('[data-notice-pause]');
  if(slides.length<2||!next||!pause)return;
  const label=slides[0].querySelector('span'),motion=matchMedia('(prefers-reduced-motion:reduce)');
  let index=0,timer,paused=motion.matches,hovered=false;
  bar.dataset.noticeReady='true';next.hidden=false;pause.hidden=false;
  const schedule=()=>{
   clearTimeout(timer);
   pause.setAttribute('aria-label',paused?bar.dataset.playLabel:bar.dataset.pauseLabel);
   pause.querySelector('span').textContent=paused?'▶':'Ⅱ';
   if(paused||hovered||document.hidden||!bar.isConnected||slides.includes(document.activeElement))return;
   timer=setTimeout(()=>{show((index+1)%slides.length);},Number(bar.dataset.interval)||2000);
  };
  const show=value=>{
   index=value;
   slides.forEach((slide,i)=>{const active=i===index;slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;slide.tabIndex=active?0:-1;});
   schedule();
  };
  const updateOffer=()=>{const text=campaign.state().redBadge?bar.dataset.offer:bar.dataset.everyday;if(label.textContent!==text)label.textContent=text;};
  next.addEventListener('click',()=>{paused=true;show((index+1)%slides.length);});
  pause.addEventListener('click',()=>{paused=!paused;schedule();});
  bar.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;schedule();}});
  bar.addEventListener('pointerleave',()=>{hovered=false;schedule();});
  bar.addEventListener('focusin',schedule);bar.addEventListener('focusout',()=>requestAnimationFrame(schedule));
  motion.addEventListener('change',()=>{paused=motion.matches;schedule();});
  document.addEventListener('visibilitychange',schedule);
  document.addEventListener('fultons:natuzzi-campaign-change',updateOffer);
  updateOffer();show(0);
 });
 setupAnnouncements();document.addEventListener('shopify:section:load',setupAnnouncements);
 const labels=document.querySelector('[data-campaign-discount-label]');
 const badge=(kind,text)=>{const s=document.createElement('span');s.className=`fultons-campaign-badge fultons-campaign-badge--${kind}`;s.dataset[kind==='offer'?'campaignOffer':'campaignChristmas']='';s.textContent=text;return s;};
 const render=()=>{
  const state=campaign.state();
  document.querySelectorAll('.living-test__card[data-product-id],.fo-card[data-product-id],[data-natuzzi-product]').forEach(card=>{
   const id=card.dataset.parentProductId||card.dataset.productId||card.dataset.natuzziProduct;if(!campaign.eligible(id))return;if(!card.matches('[data-natuzzi-product]')&&!campaign.christmasEligible(id))return;
   if(card.querySelector('[data-natuzzi-badges]'))return;
   const title=card.querySelector('.living-test__brand,h3,h1');if(!title)return;
   const group=document.createElement('div');group.className='fultons-campaign-badges';group.dataset.natuzziBadges=id;
   
   if(campaign.christmasEligible(id))group.append(badge('christmas',labels?.dataset.campaignChristmasLabel||'In time for Christmas'));
   title.before(group);
  });
  document.querySelectorAll('[data-natuzzi-badges]').forEach(group=>{
   const offer=group.querySelector('[data-campaign-offer]'),christmas=group.querySelector('[data-campaign-christmas]');
   if(offer)offer.hidden=!state.redBadge;if(christmas)christmas.hidden=!state.christmas;
   group.hidden=!(offer&&state.redBadge)&&!(christmas&&state.christmas);
  });
  document.querySelectorAll('[data-natuzzi-product]').forEach(info=>{
   if(!campaign.eligible(info.dataset.natuzziProduct))return;
   const row=info.querySelector(':scope > .fultons-retail-price .fap-price-row');
   if(!row)return;
   let offer=row.querySelector('[data-campaign-offer]');
   if(!offer&&state.redBadge){offer=badge('offer',labels?.dataset.campaignDiscountLabel||'−30%');row.append(offer);}
   if(offer)offer.hidden=!state.redBadge;
  });
 };
 let pending=false;const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;render();});};
 document.addEventListener('fultons:natuzzi-campaign-change',render);
 new MutationObserver(schedule).observe(document.querySelector('#MainContent')||document.body,{childList:true,subtree:true});render();
})();
